import Subheader from '../components/Subheader.jsx';
// import Button from 'react-bootstrap/Button';
// import { Link } from 'react-router-dom';

import gallery_img_7 from '../assets/gallery_imgs/gallery_img_7.jpg';
import artPicture from '../assets/art.jpg';
import codePicture from '../assets/code.jpg';
import EventsCard from '../components/EventsCard.jsx';

export default function EventsPage() {
	return (
		<div>
			<Subheader text="Events" />

			<div className="upcomingEvents">
				<h1 style={{ margin: '50px' }}>Upcoming Events</h1>

				<div className="events-grid">
					<div>
						<EventsCard
							image={codePicture}
							title="Computer Science Workshop In
									Collaboration with Codeazy at
									KKSS India"
							description="In collaboration with Codeazy, APL WIN will be conducting a computer science workshop at KKSS India. Codeazy is a not-for-profit organization with the aim of teaching programming and computer science to specially-abled children and children living in rural areas."
						/>
					</div>

					<div>
						<EventsCard
							image={artPicture}
							title="Art and Music Workshop At KKSS India"
							description="APL WIN will be conducting an art workshop at KKSS India."
						/>
					</div>
				</div>
				{/* <Link to="/gallery">
						<Button className="homepage-section2_buttonlink">
							View Gallery
						</Button>
					</Link>
				*/}
			</div>

			<div className="pastEvents">
				<h1 style={{ margin: '50px' }}>Past Events</h1>
				<div className="events-grid">
					<EventsCard
						image={gallery_img_7}
						title="APL Global Cultural Evening Bake
								Sale"
						description="APL WIN conducted a bake sale on
								the 6th of August 2022 in APL
								Global School, Thoraipakkam, Tamil
								Nadu, to raise funds for the Bala
								Mandir Kamraj Trust. The profit earned from the bake sale was donated to the trust in multiple forms including books for 9th and 10th graders and shoes"
					/>
				</div>
			</div>
		</div>
	);
}
